// @module Eureka.MaxaCreditApplication.MaxaCreditApplication
define('Eureka.MaxaCreditApplication.MaxaCreditApplication.View'
,	[
	'eureka_maxacreditapplication_maxacreditapplication.tpl'
	
	,	'Eureka.MaxaCreditApplication.MaxaCreditApplication.SS2Model'
	
	,	'Backbone'
    ]
, function (
	eureka_maxacreditapplication_maxacreditapplication_tpl
	
	,	MaxaCreditApplicationSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class Eureka.MaxaCreditApplication.MaxaCreditApplication.View @extends Backbone.View
	return Backbone.View.extend({

		template: eureka_maxacreditapplication_maxacreditapplication_tpl

		, mainSchema: {
			creditFirstName: function (value) {
				return (/[a-zA-Z0-9-]+/.test(value))
			},
			creditLastName: function (value) {
				return (/[a-zA-Z0-9-]+/.test(value))
			},
			creditEmail: function (value) {
				return value.match(
					/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
				);
			},
			creditPhone: function (value) {
				return value && !isNaN(value)
			},
			creditCompany: function (value) {
				return (/[a-zA-Z0-9-]+/.test(value))
			},
			creditAmount: function (value) {
				value = Number(value.replace(/[^0-9.-]+/g, ""));
				return !isNaN(value) && parseFloat(value)
			},
			trailerAmount: function (value) {
				return value && !isNaN(value)
			},
		}

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new MaxaCreditApplicationModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
			'submit form': 'saveCustomForm',
			'change [id="creditAmount"]': 'changeCurrency'
		}

	,	bindings: {
		}

	, 	childViews: {

		}

	,	changeCurrency: function (e){
			let value = e.currentTarget.value
			e.currentTarget.setCustomValidity('');
			e.currentTarget.value = '£' + Number(value).toLocaleString('en');
		}

	,	saveCustomForm: function saveCustomForm() {
			let data = {
				creditFirstName: document.getElementById("creditFirstName").value,
				creditLastName: document.getElementById("creditLastName").value,
				creditEmail: document.getElementById("creditEmail").value,
				creditPhone: document.getElementById("creditPhone").value,
				creditCompany: document.getElementById("creditCompany").value,
				creditAmount: document.getElementById("creditAmount").value,
				trailerAmount: document.getElementById("trailerAmount").value
			}
			let valid = true
			let isValid = this.validate(data, this.mainSchema)
			isValid.forEach(function (error) {
				let elementId = "error" + error.message
				document.getElementById(elementId).hidden = false
				valid = false
			})

			if(valid){
				let creditModel = new MaxaCreditApplicationSS2Model();
				creditModel.fetch({data: data}).done(function(result) {
					return result.success
				});
			}
		}

	, validate: function (data, schema) {
			return Object.keys(schema).map(function (property) {
				var validator = schema[property];

				return [property, !validator.required || (property in data), validator(data[property])];
			}).filter(function (entry) {
				return !entry[1] || !entry[2];
			}).map(function (entry) {
				if (!entry[1]) return new Error(entry[0]);
				else return new Error(entry[0]);
			});
		}
		//@method getContext @return Eureka.MaxaCreditApplication.MaxaCreditApplication.View.Context
	,	getContext: function getContext()
		{
			//@class Eureka.MaxaCreditApplication.MaxaCreditApplication.View.Context
			return {
				message: this.message
			};
		}
	});
});
